"use strict";

/* eslint no-undef: "off" */
/**
 * header menu
 */
define('logo',[], function () {
  return {
    template: "\n      <div class=\"xp-logo-image\">\n        <img class=\"\" :src=\"logo.url\" />\n      </div>\n    ",
    data: function data() {
      return {
        logo: window.commonDataJSON.logo
      };
    }
  };
});
